// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Js_exn = require("rescript/lib/js/js_exn.js");
var RelayEnv = require("../../RelayEnv.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var PageTitle = require("../../reason/common/PageTitle.bs.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
var SystemMessage = require("../../uikit/reason/molecules/SystemMessage/SystemMessage.bs.js");
var Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
var Form__Validators = require("../../reason/common/Form/Form__Validators.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var Formality__Debouncer = require("../../vendor/re-formality/Formality__Debouncer.bs.js");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var RequestPasswordResetPageRelayQuery_graphql = require("../../__generated__/RequestPasswordResetPageRelayQuery_graphql.bs.js");
var RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql = require("../../__generated__/RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql.bs.js");

var genericError = "There was a problem submitting your password reset request. Please try again or contact support";

var invalidEmailError = "There was a problem submitting your password reset request. Please verify if the email you entered is correct";

var convertVariables = RequestPasswordResetPageRelayQuery_graphql.Internal.convertVariables;

var convertResponse = RequestPasswordResetPageRelayQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = RequestPasswordResetPageRelayQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, RequestPasswordResetPageRelayQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, RequestPasswordResetPageRelayQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(RequestPasswordResetPageRelayQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(RequestPasswordResetPageRelayQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(RequestPasswordResetPageRelayQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(RequestPasswordResetPageRelayQuery_graphql.node, convertVariables);

var Query_emailRegistrationStatus_decode = RequestPasswordResetPageRelayQuery_graphql.Utils.emailRegistrationStatus_decode;

var Query_emailRegistrationStatus_fromString = RequestPasswordResetPageRelayQuery_graphql.Utils.emailRegistrationStatus_fromString;

var Query = {
  emailRegistrationStatus_decode: Query_emailRegistrationStatus_decode,
  emailRegistrationStatus_fromString: Query_emailRegistrationStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

async function validate(email) {
  var val;
  try {
    val = await fetchPromised(RelayEnv.environment, {
          email: email
        }, undefined, "network-only");
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Js_exn.$$Error) {
      return {
              TAG: "Error",
              _0: genericError
            };
    }
    throw exn;
  }
  var match = val.emailRegistrationStatus;
  if (match === undefined) {
    return {
            TAG: "Error",
            _0: "email is not registered"
          };
  }
  var tmp = match.status;
  if ((tmp === "AVAILABLE" || tmp === "REGISTERED") && tmp !== "AVAILABLE") {
    return {
            TAG: "Ok",
            _0: undefined
          };
  } else {
    return {
            TAG: "Error",
            _0: "email is not registered"
          };
  }
}

var ValidateEmailAsync = {
  Query: Query,
  validate: validate
};

var validators = {
  email: {
    strategy: "OnFirstSuccessOrFirstBlur",
    validate: (function (param, param$1) {
        var email = Form__Helpers.noneIfEmpty(param.email);
        if (email !== undefined) {
          if (Belt_Result.isOk(Form__Validators.isEmail(email))) {
            return {
                    TAG: "Ok",
                    _0: email
                  };
          } else {
            return {
                    TAG: "Error",
                    _0: "Please enter a valid email."
                  };
          }
        } else {
          return {
                  TAG: "Error",
                  _0: "is required"
                };
        }
      }),
    validateAsync: Formality__Debouncer.make(700, (function (param) {
            var dispatch = param[2];
            var value = param[0];
            var validate = function (email, param) {
              var __x = param.validateEmail(email);
              return Js_promise.then_((function (res) {
                            var tmp;
                            tmp = res.TAG === "Ok" ? ({
                                  TAG: "Ok",
                                  _0: email
                                }) : ({
                                  TAG: "Error",
                                  _0: res._0
                                });
                            return Promise.resolve(tmp);
                          }), __x);
            };
            Formality.Async.validateAsyncWithMetadata(value, param[1], validate, (function (res) {
                    dispatch({
                          TAG: "ApplyAsyncResultForEmailField",
                          _0: value,
                          _1: res
                        });
                  }));
          })),
    eq: (function (prim0, prim1) {
        return prim0 === prim1;
      })
  }
};

function initialFieldsStatuses(_input) {
  return {
          email: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            email: "Pristine"
          },
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var value = fieldsStatuses.email;
  var match;
  match = typeof value !== "object" ? ({
        NAME: "Result",
        VAL: validators.email.validate(input, metadata)
      }) : (
      value.TAG === "Dirty" ? ({
            NAME: "Result",
            VAL: value._0
          }) : ({
            NAME: "Validating",
            VAL: value._0
          })
    );
  if (match.NAME !== "Result") {
    return {
            TAG: "Validating",
            fieldsStatuses: {
              email: match.NAME === "Result" ? ({
                    TAG: "Dirty",
                    _0: match.VAL,
                    _1: "Shown"
                  }) : ({
                    TAG: "Validating",
                    _0: match.VAL
                  })
            },
            collectionsStatuses: undefined
          };
  }
  var emailResult = match.VAL;
  if (emailResult.TAG === "Ok") {
    return {
            TAG: "Valid",
            output: {
              email: emailResult._0
            },
            fieldsStatuses: {
              email: {
                TAG: "Dirty",
                _0: emailResult,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
  } else {
    return {
            TAG: "Invalid",
            fieldsStatuses: {
              email: {
                TAG: "Dirty",
                _0: emailResult,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
  }
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurEmailField" :
                  var result = Formality.Async.validateFieldOfStringTypeOnBlurWithMetadata(state.input, metadata, state.fieldsStatuses.email, validators.email, (function (status) {
                          return {
                                  email: status
                                };
                        }));
                  if (result === undefined) {
                    return "NoUpdate";
                  }
                  var value = result.email;
                  if (typeof value === "object" && value.TAG !== "Dirty") {
                    var value$1 = value._0;
                    return {
                            TAG: "UpdateWithSideEffects",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                validators.email.validateAsync([
                                      value$1,
                                      metadata,
                                      param.dispatch
                                    ]);
                              })
                          };
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: result,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
                  break;
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  switch (match$1.TAG) {
                    case "Valid" :
                        var output = match$1.output;
                        var error = state.formStatus;
                        var tmp;
                        tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
                        return {
                                TAG: "UpdateWithSideEffects",
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: {
                                    TAG: "Submitting",
                                    _0: tmp
                                  },
                                  submissionStatus: "AttemptedToSubmit"
                                },
                                _1: (function (param) {
                                    var dispatch = param.dispatch;
                                    onSubmit(output, {
                                          notifyOnSuccess: (function (input) {
                                              dispatch({
                                                    TAG: "SetSubmittedStatus",
                                                    _0: input
                                                  });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              dispatch({
                                                    TAG: "SetSubmissionFailedStatus",
                                                    _0: error
                                                  });
                                            }),
                                          reset: (function () {
                                              dispatch("Reset");
                                            }),
                                          dismissSubmissionResult: (function () {
                                              dispatch("DismissSubmissionResult");
                                            })
                                        });
                                  })
                              };
                    case "Invalid" :
                        return {
                                TAG: "Update",
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: "Editing",
                                  submissionStatus: "AttemptedToSubmit"
                                }
                              };
                    case "Validating" :
                        return {
                                TAG: "Update",
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: state.formStatus,
                                  submissionStatus: state.submissionStatus
                                }
                              };
                    
                  }
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateEmailField" :
                  var nextInput = action._0(state.input);
                  var nextFieldsStatuses = Formality.Async.validateFieldOfStringTypeOnChangeInOnChangeModeWithMetadata(nextInput, metadata, state.fieldsStatuses.email, state.submissionStatus, validators.email, (function (status) {
                          return {
                                  email: status
                                };
                        }));
                  var value$2 = nextFieldsStatuses.email;
                  if (typeof value$2 === "object" && value$2.TAG !== "Dirty") {
                    var value$3 = value$2._0;
                    return {
                            TAG: "UpdateWithSideEffects",
                            _0: {
                              input: nextInput,
                              fieldsStatuses: nextFieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                validators.email.validateAsync([
                                      value$3,
                                      metadata,
                                      param.dispatch
                                    ]);
                              })
                          };
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: nextFieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "ApplyAsyncResultForEmailField" :
                  var validator = validators.email;
                  var x = state.fieldsStatuses.email;
                  if (typeof x !== "object" || x.TAG === "Dirty" || !validator.eq(x._0, action._0)) {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                email: {
                                  TAG: "Dirty",
                                  _0: action._1,
                                  _1: "Shown"
                                }
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                email: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                email: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: map(error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateEmail: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateEmailField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurEmail: (function () {
              dispatch("BlurEmailField");
            }),
          emailResult: Formality.Async.exposeFieldResult(state.fieldsStatuses.email),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.email;
              if (typeof tmp !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              switch (match.TAG) {
                case "Valid" :
                    return true;
                case "Invalid" :
                    return false;
                case "Validating" :
                    return ;
                
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var FormConfig = {
  debounceInterval: 700,
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var convertVariables$1 = RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql.Internal.convertVariables;

var convertResponse$1 = RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$1, RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var CreatePasswordResetTokenV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation,
  use: use$1
};

function RequestPasswordResetPageRelay(props) {
  var match = use$1();
  var createPasswordResetToken = match[0];
  var form = useForm({
        email: ""
      }, {
        validateEmail: validate
      }, (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          createPasswordResetToken({
                input: {
                  email: param.email
                }
              }, undefined, undefined, undefined, (function (response, param) {
                  var match = response.createPasswordResetTokenV5;
                  if (match === undefined) {
                    return notifyOnFailure(genericError);
                  }
                  switch (match.__typename) {
                    case "CreatePasswordResetTokenInvalidEmailError" :
                        return notifyOnFailure(invalidEmailError);
                    case "PasswordResetTokenCreated" :
                        return notifyOnSuccess(undefined);
                    case "__unselected" :
                        return notifyOnFailure(genericError);
                    
                  }
                }), (function (param) {
                  notifyOnFailure(genericError);
                }), undefined);
        }));
  var match$1 = form.status;
  var tmp;
  var exit = 0;
  if (typeof match$1 !== "object" && match$1 === "Submitted") {
    tmp = JsxRuntime.jsx(SystemMessage.make, {
          id: "form_submitted",
          text: "Instructions to reset your password have been emailed to you. Please check your email.",
          type_: "success",
          secondary: true,
          handleOnDismiss: (function (_id) {
              
            })
        });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    var msg = form.status;
    var tmp$1;
    tmp$1 = typeof msg !== "object" || msg.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx(SystemMessage.make, {
            id: "form_submitted",
            time: 5000,
            text: msg._0,
            type_: "error",
            dismissible: true,
            secondary: true,
            handleOnDismiss: (function (_id) {
                form.dismissSubmissionResult();
              })
          });
    var match$2 = form.emailResult;
    var tmp$2;
    if (match$2 !== undefined && match$2.TAG !== "Validating") {
      var err = match$2._0;
      tmp$2 = err.TAG === "Ok" ? undefined : ({
            NAME: "Error",
            VAL: err._0
          });
    } else {
      tmp$2 = undefined;
    }
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            tmp$1,
            JsxRuntime.jsxs("form", {
                  children: [
                    JsxRuntime.jsx(Form__Input.make, {
                          labelText: "Your email",
                          placeholderText: "Enter your email",
                          onChange: (function ($$event) {
                              form.updateEmail((function (param, value) {
                                      return {
                                              email: value
                                            };
                                    }), $$event.target.value);
                            }),
                          onBlur: (function (param) {
                              form.blurEmail();
                            }),
                          disabled: form.submitting,
                          status: Belt_Option.flatMap(form.emailResult, (function (x) {
                                  if (x.TAG === "Validating") {
                                    return ;
                                  } else if (x._0.TAG === "Ok") {
                                    return "ok";
                                  } else {
                                    return "error";
                                  }
                                })),
                          value: form.input.email
                        }),
                    JsxRuntime.jsx(Form__Components.FieldError.make, {
                          valid: tmp$2
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                disabled: form.submitting,
                                _type: "submit",
                                children: Caml_option.some(form.submitting ? "Submitting..." : "Reset password")
                              }),
                          className: "flex items-center justify-center mt-8"
                        })
                  ],
                  className: "mt-2",
                  onSubmit: (function (e) {
                      e.preventDefault();
                      form.submit();
                    })
                })
          ]
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      children: tmp,
                      className: "bg-white p-5 shadow rounded-md"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ButtonsV5.Link.make, {
                            href: "/login",
                            children: "Login"
                          }),
                      className: "flex justify-center mt-8"
                    }),
                JsxRuntime.jsx(PageTitle.make, {
                      title: "Reset Password"
                    })
              ]
            });
}

var make = RequestPasswordResetPageRelay;

var $$default = RequestPasswordResetPageRelay;

exports.genericError = genericError;
exports.invalidEmailError = invalidEmailError;
exports.ValidateEmailAsync = ValidateEmailAsync;
exports.FormConfig = FormConfig;
exports.CreatePasswordResetTokenV5Mutation = CreatePasswordResetTokenV5Mutation;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
